import { render, staticRenderFns } from "./OrderItemSettings.vue?vue&type=template&id=1ff1eff1&"
import script from "./OrderItemSettings.vue?vue&type=script&lang=js&"
export * from "./OrderItemSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports